export default "__VITE_ASSET__CF8vO$8G__"